import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer group">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-primary-500 text-xl"></i>
                </div>
                <span className="text-lg font-heading font-bold text-foreground-50 whitespace-nowrap">
                  久久影视
                </span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed">
                久久影视提供高清免费影视在线观看，聚合海量免费高清电影、高清电视剧，画质清晰不缓冲，零成本畅享高清视听盛宴。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-foreground-50 mb-4">影视分类</h4>
              <ul className="flex flex-col gap-2.5">
                {categories.filter(c => c.slug !== 'all').map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-foreground-50 mb-4">快速链接</h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/movies"
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    最新电影
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/tv-shows"
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    热播剧集
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-foreground-50 mb-4">联系我们</h4>
              <ul className="flex flex-col gap-2.5">
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-foreground-500 text-xs"></i>
                  </div>
                  contact@jiujiutv.com
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line text-foreground-500 text-xs"></i>
                  </div>
                  400-888-9999
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600">
              &copy; {new Date().getFullYear()} 久久影视 JiujiuTV. 保留所有权利。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
                使用条款
              </a>
              <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}